import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Link from '../../shared/components/Link/Link';
import CustomReactMarkdown from '../../shared/components/MarkdownRenderers/CustomReactMarkdown';


class HomepageFeaturedPrograms extends Component {
  static getDomId() {
    return 'slot_homepage_featured_programs';
  }

  static getComponentData() {
    return { programs: window.seMarketplace[this.getDomId()] };
  }

  render() {
    const { programs } = this.props;

    if (programs.length === 0) {
      return null;
    }
    return (
      <div className="se-tier">
        <div className="se-container">
          <h2 className="slot-homepage-featured-programs__section-title">Featured Programs</h2>
          <div className="slot-homepage-featured-programs__list">
            {programs.map(program => (
              <div key={program.title} className="slot-homepage-featured-programs__card-wrapper">
                <Link className="slot-homepage-featured-programs__card" href={program.url} external={program.external}>
                  <div className="slot-homepage-featured-programs__card-body">
                    <div className="slot-homepage-featured-programs__image-wrapper">
                      <img
                        className="slot-homepage-featured-programs__image"
                        src={program.image}
                        alt={program.title}
                      />
                    </div>
                    <div className="slot-homepage-featured-programs__description-wrapper">
                      <div className="slot-homepage-featured-programs__title">
                        <CustomReactMarkdown noWrapper source={program.title} />
                      </div>
                      <div className="slot-homepage-featured-programs__body">
                        <CustomReactMarkdown noWrapper source={program.description} />
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

HomepageFeaturedPrograms.propTypes = {
  programs: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  })),
};

HomepageFeaturedPrograms.defaultProps = {
  programs: [],
};


export default HomepageFeaturedPrograms;
